import { useState } from "react";
import { useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  ClickAwayListener,
  InputBase,
  MenuItem,
  MenuList,
  Paper,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ExtraSmallAvatar } from "../../styles/materialUi/avatar";
import { buildAlumPath } from "../../constants/routes";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import "./alumniSearch.scss";

const propTypes = {
  cohorts: PropTypes.objectOf(PropTypes.any).isRequired,
  allAlumni: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

const AlumniSearch = ({ cohorts, allAlumni }) => {
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [focusSuggestions, setFocusSuggestions] = useState(false);
  const history = useHistory();

  const handleInputChange = (value) => {
    setInput(value);
    if (value.length === 0) {
      setSuggestions([]);
    } else {
      const matchedAlumni = allAlumni.filter((alum) => {
        const fullName = `${alum.firstName} ${alum.lastName}`;
        return fullName.includes(value.toLowerCase());
      });
      setSuggestions(matchedAlumni);
    }
  };

  const closeMenu = () => {
    setFocusSuggestions(false);
    setInput("");
    setSuggestions([]);
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setFocusSuggestions(true);
        break;
      default:
        break;
    }
  };

  const menuItems = suggestions.slice(0, 10).map((alum) => {
    const cohort = cohorts[alum.cohortID] || {};
    return (
      <MenuItem
        key={alum.id}
        onKeyDown={(e) =>
          e.key === "Enter" && history.push(buildAlumPath(alum.owner))
        }
        onClick={() => history.push(buildAlumPath(alum.owner))}
      >
        <ProfilePicture
          profileId={alum.id}
          avatar={ExtraSmallAvatar}
          editable={false}
          alt={alum.firstNameDisplay || ""}
          objectKey={alum.profilePictureKey}
          linkedInPicUrl={alum.ProfilePicture}
        />
        <Typography className="name" variant="inherit">
          {alum.firstNameDisplay} {alum.lastNameDisplay}
        </Typography>
        <Typography variant="body2">
          <span className="dot">&#8226;</span>
          {cohort.name}
        </Typography>
      </MenuItem>
    );
  });

  return (
    <div className="alumni-search">
      <div className="search-field">
        <SearchIcon />
        <InputBase
          placeholder="Search"
          inputProps={{ "aria-label": "search" }}
          fullWidth
          value={input}
          onChange={(e) => handleInputChange(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      {suggestions.length > 0 && (
        <ClickAwayListener onClickAway={closeMenu}>
          <Paper className="suggestions" elevation={6}>
            <MenuList variant="menu" autoFocusItem={focusSuggestions}>
              {menuItems}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      )}
    </div>
  );
};

AlumniSearch.propTypes = propTypes;

export default AlumniSearch;
